var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyanmar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_237",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3H33V13H3V3Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13H33V23H3V13Z",
    fill: "#EA2839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9.66667H33V16.3333H3V9.66667Z",
    fill: "#34B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6047 13.7033L18 6.33332L20.3952 13.7033H15.6047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9377 15.1112L13.6679 19.6658L16.0621 12.2954L19.9377 15.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 15.9813L10.9907 11.4259L18.7402 11.4253L17.2598 15.9813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 11.4253L25.0092 11.4259L18.7401 15.9813L17.2598 11.4253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9377 12.2954L22.3319 19.6658L16.0621 15.1112L19.9377 12.2954Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_237",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_237",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyanmar);
export default __webpack_public_path__ + "static/media/Myanmar.5d181e1feba07e29109b3f1d82ea7ecd.svg";
export { ForwardRef as ReactComponent };